// charge bootstrap button
// import 'bootstrap/js/dist/button'

// Scripts
import noUiSlider from 'nouislider'
import wNumb from '../../js/libs/wnumb-1.2.0/wNumb.min.js'

// Styles
import 'nouislider/dist/nouislider.css'
import '../../scss/components/offersFilterForm'

const ofForm = {
  $f: $('form[name="ofForm"]'),

  init () {
    const _this = this
    $.each(_this.$f, function (i, elem) {
      // superficie
      const range1 = $(elem).find('.surface-range')[0]
      if (typeof range1 !== 'undefined') {
        const surfaceFormat = wNumb({
          decimals: 0,
          thousand: '.',
          postfix: ' m²'
        })
        const skipValues = [
          $(elem).find('.surface-value-min')[0],
          $(elem).find('.surface-value-max')[0]
        ]
        const inputValues = [
          $(elem).find('input[name="surface_from"]')[0],
          $(elem).find('input[name="surface_to"]')[0]
        ]
        const minv = parseInt($(elem).find('input[name="surface_min"]').val())
        const maxv = parseInt($(elem).find('input[name="surface_max"]').val())
        noUiSlider.create(range1, {
          start: [minv, maxv],
          step: 10,
          connect: true,
          range: {
            min: minv,
            max: maxv
          },
          format: surfaceFormat
        })
        if (inputValues[0].value !== '' && inputValues[1].value !== '') {
        // if (inputValues[0].value !== '') {
          range1.noUiSlider.set([inputValues[0].value, inputValues[1].value]) // affecte les valeurs
        } else {
          range1.noUiSlider.set([minv, maxv]) // affecte les valeurs par défaut
        }
        range1.noUiSlider.on('update', function (values, handle) { // relie le snap aux inputs
          skipValues[handle].innerHTML = values[handle]
          if (surfaceFormat.from(values[handle]) === maxv) {
            skipValues[handle].innerHTML = values[handle] + '&nbsp;<small>et&nbsp;+</small>'
          }
          inputValues[handle].value = surfaceFormat.from(values[handle])
        })
      }

      // budget
      const range2 = $(elem).find('.budget-range')[0]
      if (typeof range2 !== 'undefined') {
        const moneyFormat = wNumb({
          decimals: 0,
          thousand: '.',
          postfix: ' €'
        })
        const skipValues = [
          $(elem).find('.budget-value-min')[0],
          $(elem).find('.budget-value-max')[0]
        ]
        const inputValues = [
          $(elem).find('input[name="budget_from"]')[0],
          $(elem).find('input[name="budget_to"]')[0]
        ]
        const minv2 = parseInt($(elem).find('input[name="budget_min"]').val())
        const maxv2 = parseInt($(elem).find('input[name="budget_max"]').val())
        noUiSlider.create(range2, {
          start: [minv2],
          step: 10000,
          connect: [true, false],
          range: {
            min: minv2,
            max: maxv2
          },
          format: moneyFormat
        })
        // if (inputValues[0].value !== '' && inputValues[1].value !== '') {
        if (inputValues[0].value !== '') {
          range2.noUiSlider.set([inputValues[0].value, inputValues[1].value]) // affecte les valeurs
        } else {
          range2.noUiSlider.set([maxv2]) // affecte les valeurs par défaut
        }
        range2.noUiSlider.on('update', function (values, handle) { // relie le snap aux inputs
          skipValues[handle].innerHTML = values[handle]
          if (moneyFormat.from(values[handle]) === maxv2) {
            skipValues[handle].innerHTML = values[handle] + '&nbsp;<small>et&nbsp;+</small>'
          }
          inputValues[handle].value = moneyFormat.from(values[handle])
        })
      }

      // on raz
      $(elem).find('button[name="btn_raz"]').on('click', function () {
        $(elem)[0].reset() // reset le formulaire
        $(elem).find('input[name="type"]').val('')
        $(elem).find('input[name="slug"]').val('')
        const minv = parseInt($(elem).find('input[name="surface_min"]').val())
        const maxv = parseInt($(elem).find('input[name="surface_max"]').val())
        $(elem).find('input[name="surface_from"]').val(minv)
        $(elem).find('input[name="surface_to"]').val(maxv)
        const minv2 = parseInt($(elem).find('input[name="budget_min"]').val())
        const maxv2 = parseInt($(elem).find('input[name="budget_max"]').val())
        $(elem).find('input[name="budget_from"]').val(maxv2)
        $(elem).find('input[name="budget_to"]').val(minv2)
        $(elem).submit()
      })

      // on submit
      $(elem).on('submit', function () {
        $(elem).attr('action', $(elem).find('input[name="category[]"]:checked').val())
        if ($(elem).find('input[name="slug"]').val() !== '') { $(elem).attr('action', $(elem).attr('action') + '/' + $(elem).find('input[name="slug"]').val()) }
      })
    })
  }

}

ofForm.init()
